import { render, staticRenderFns } from "./DuplicateElementModal.vue?vue&type=template&id=10eea57b&scoped=true&"
import script from "./DuplicateElementModal.vue?vue&type=script&lang=ts&"
export * from "./DuplicateElementModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10eea57b",
  null
  
)

export default component.exports